import { SrcSetProps } from "@at/design-system-elements";

export const getVideoImageLink = (
  videoId: string | undefined,
  size: "s" | "m" | "l" | "xl",
) => {
  return `https://www.autotrader.co.uk/you-tube/image/${size}/${videoId || ""}`;
};

export const expertImageSizes = (videoId: string): SrcSetProps[] => {
  return [
    {
      srcSet: [
        {
          url: getVideoImageLink(`${videoId}`, "s"),
          dimensions: [{ width: "320" }],
        },
        {
          url: getVideoImageLink(`${videoId}`, "m"),
          dimensions: [{ width: "640" }],
        },
        {
          url: getVideoImageLink(`${videoId}`, "xl"),
          dimensions: [{ width: "1024" }],
        },
      ],
      size: [
        {
          mq: "320",
          unit: "320",
        },
        {
          mq: "640",
          unit: "640",
        },
        {
          mq: "1024",
          unit: "1024",
        },
      ],
    },
  ];
};
